export default "__VITE_ASSET__B25LIB7k__"